/* eslint-disable camelcase */
import { useMemo } from 'react';
import { useCookies } from 'react-cookie';

const { NODE_ENV } = process.env;

export const AUTH_TOKEN_KEY = 'trybe_fintech_token';
export const AUTH_STATE = 'auth_0_state';
export const AUTH_IDENTITY_DATA = 'auth_identity_data';

export const options = {
  domain: window.location.hostname,
  path: '/',
  secure: NODE_ENV === 'production',
};

export type LoginResponseProps = {
  data: {
    access_token: string;
    refresh_token: string;
    sleekplan_token: string;
    user: {
      email: string;
      id: string;
      name: string;
      roles: string[];
    };
  };
};

export type UseTokenTypes = {
  token: string;
  state: string;
  loginIndentityData: LoginResponseProps;
  setToken: (value: string) => void;
  setState: (value: string) => void;
  setLoginIndentityData: (value: LoginResponseProps) => void;
  removeToken: () => void;
  removeState: () => void;
  removeLoginIndentityData: () => void;
  clearAll: () => void;
};

function useToken(): UseTokenTypes {
  const [cookies, setCookie, removeCookie] = useCookies([
    AUTH_TOKEN_KEY,
    AUTH_STATE,
    AUTH_IDENTITY_DATA,
  ]);

  const token = useMemo(() => cookies?.[AUTH_TOKEN_KEY] || null, [cookies]);
  const setToken = (value: string) => setCookie(AUTH_TOKEN_KEY, value);
  const removeToken = () => removeCookie(AUTH_TOKEN_KEY);

  const state = useMemo(() => cookies?.[AUTH_STATE] || null, [cookies]);
  const setState = (value: string) => setCookie(AUTH_STATE, value);
  const removeState = () => removeCookie(AUTH_STATE);

  const loginIndentityData = useMemo(
    () => cookies?.[AUTH_IDENTITY_DATA] || null,
    [cookies],
  );
  const setLoginIndentityData = (value: LoginResponseProps) =>
    setCookie(AUTH_IDENTITY_DATA, value);
  const removeLoginIndentityData = () => removeCookie(AUTH_IDENTITY_DATA);

  const clearAll = () => {
    removeCookie(AUTH_TOKEN_KEY);
    removeCookie(AUTH_STATE);
    removeCookie(AUTH_IDENTITY_DATA);
  };

  return {
    token,
    state,
    loginIndentityData,
    setToken,
    setState,
    setLoginIndentityData,
    removeToken,
    removeState,
    removeLoginIndentityData,
    clearAll,
  };
}

export default useToken;
